import React, { useState,useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Box, Typography, FormControl, Select, MenuItem, TextField, FormControlLabel, CircularProgress } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { Switch, styled } from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import userimg from '../../../assets/images/user_img.png'; // Import your static image
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
import axios from 'axios';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: 'green',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: 'red',
    opacity: 1,
  },
}));

const MyTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true); 
      useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('authToken'); 
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/orders/admin/allorders`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                console.log(response.data)
                if (response.data.success) {
                    // setData(response.data.orders); 
                    const sortedOrders = response.data.orders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                    setData(sortedOrders); // Store the sorted orders in state
                } else {
                    toast.error('Failed to fetch orders');
                }
            } catch (error) {
                toast.error('Error fetching orders');
            }
            finally {
              setLoading(false); 
          }
        };

        fetchData();
    }, []);
      
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const allIds = data.map(item => item._id);
      setSelectedRows(allIds);
    }
    setSelectAll(!selectAll);
  };

  const handleRowCheckboxChange = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter(id => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };


  const navigate = useNavigate();

  const columns = [
    {
      name: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} checked={selectAll} onChange={handleSelectAll}>
          <Box>
            <input type="checkbox" />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', color: 'green' }}>
            <Delete
              sx={{
                cursor: 'pointer',
                padding: '0px',
                fontSize: '18px',
              }}
              onClick={() => alert('Delete all items action triggered!')}
            />
            <Typography variant="body1">All</Typography>
          </Box>
        </Box>
      ),
      selector: row => row._id,
      cell: (row) => (
        <input type="checkbox" checked={selectedRows.includes(row._id)} 
          onChange={() => handleRowCheckboxChange(row.id)} />
      ),
      sortable: false,
      style: {
        padding: '8px',
        textAlign: 'center',
      },
    },
    {
      name: 'Order ID',
      selector: row => row._id,
      sortable: true,
      cell: row => (
        <Typography
          variant="body1"
          sx={{ fontSize:'14px',color: '#3c7f06', fontWeight: '300',cursor:'pointer' }} 
          onClick={() => navigate(`/orders/edit/${row._id}`)}
        >
          {row._id}
        </Typography>
      ),
      style: {
        padding: '8px',
      },
    },
    {
        name: 'Client',
        selector: row => row.billingDetails.name,
        cell: row => (
          <Typography
            variant="body1"
            sx={{ fontSize:'14px',color: '#3c7f06', fontWeight: '300',cursor:'pointer' }}  
            onClick={() => navigate(`/users-customer/edit/${row._id}`)}
          >
            {row.billingDetails.name}
          </Typography>
        ),
        sortable: true,
        style: {
          padding: '8px',
        },
      },
      {
        name: 'Date',
        selector: row => {
          // Convert the 'createdAt' ISO string to a Date object
          const date = new Date(row.createdAt);
          
          // Extract the year, month, and day
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
          const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
      
          // Extract the hours, minutes, and seconds
          let hours = date.getHours();
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          
          // Determine AM/PM
          const period = hours >= 12 ? 'PM' : 'AM';
          
          // Convert to 12-hour format
          hours = hours % 12; // Convert hour from 24-hour to 12-hour format
          hours = hours ? hours : 12; // Adjust hour 0 to 12 for midnight
          const formattedHours = String(hours).padStart(2, '0');
      
          // Combine the date and time as 'YYYY-MM-DD hh:mm:ss AM/PM'
          return `${year}-${month}-${day} ${formattedHours}:${minutes}:${seconds} ${period}`;
        },
        sortable: true,
        style: {
          padding: '8px',
        },
      },
    {
      name: 'Amount',
      selector: row => row.orderItems.orderTotal,
      sortable: true,
      cell: row => (
        <Typography
          variant="body1"
          sx={{ fontSize:'14px',color: '#3c7f06', fontWeight: '600' }} 
        >
          ₹{row.orderItems.orderTotal}
        </Typography>
      ),
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Order Status',
      selector: row => row.generalDetails.status,
      sortable: true,
      cell:row=>(
        <Box
          className={`${row.generalDetails.status.toLowerCase()}-cls`}
        >
          {row.generalDetails.status}
        </Box>
      ),
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Actions',
      cell: row => (
        <Box sx={{ display: 'flex', gap: 2 }}>
          <VisibilityIcon sx={{
              cursor: 'pointer',
              backgroundColor: '#E1E7E9',
              color: '#000',
              borderRadius: '50%',
              padding: '5px',
              fontSize: '28px',
            }}
            // onClick={() => navigate(`view/${row.id}`)}
            />
            <PrintIcon sx={{
              cursor: 'pointer',
              backgroundColor: '#E1E7E9',
              color: '#000',
              borderRadius: '50%',
              padding: '5px',
              fontSize: '28px',
            }}
            // onClick={() => navigate(`view/${row.id}`)}
            />
          <Delete
            sx={{
              cursor: 'pointer',
              backgroundColor: 'red',
              color: '#fff',
              borderRadius: '50%',
              padding: '6px',
              fontSize: '28px',
            }}
            // onClick={() => deleteItem(row.id)}
          />
        </Box>
      ),
      sortable: false,
      style: {
        padding: '8px',
      },
    },
  ];

  const filteredData = data.filter(item =>
    (item._id && item._id.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (item.driver && item.driver.driverName && item.driver.driverName.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (item.billingDetails && item.billingDetails.name && item.billingDetails.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (item.generalDetails && item.generalDetails.status && item.generalDetails.status.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const startIndex = (page - 1) * entriesPerPage;
  const currentPageData = filteredData.slice(startIndex, startIndex + entriesPerPage);

  const handleEntriesChange = event => {
    setEntriesPerPage(event.target.value);
    setPage(1); // Reset page to 1 when changing entries per page
  };

  const handleSearchChange = event => {
    setSearchTerm(event.target.value);
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" sx={{ mr: 1 }}>
            Show
          </Typography>
          <FormControl sx={{ p: 1 }}>
            <Select
              value={entriesPerPage}
              onChange={handleEntriesChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Entries per page' }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="body1" sx={{ mr: 1 }}>
            entries
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" sx={{ mr: 1 }}>
            Search:
          </Typography>
          <TextField
            className="recent-or-search-cls"
            id="outlined-basic"
            label=""
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            size="small"
          />
        </Box>
      </Box>

      <Box sx={{ border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden' }}>
      {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
            <CircularProgress />
            <Typography variant="body1" sx={{ marginLeft: 2 }}>Orders loading...</Typography>
          </Box>
        ) : (

        <DataTable
          columns={columns}
          data={currentPageData}
          pagination
          paginationServer
          paginationTotalRows={filteredData.length}
          onChangePage={newPage => setPage(newPage)}
          paginationPerPage={entriesPerPage}
          paginationComponentOptions={{
            noRowsPerPage: true,
          }}
          customStyles={{
            table: {
              style: {
                tableLayout: 'auto',
              },
            },
            cells: {
              style: {
                padding: '8px',
                border: '1px solid #dee2e6',
                color: '#67757c',
                fontSize: '14px',
              },
            },
            headCells: {
              style: {
                backgroundColor: '#f4f4f4',
                fontWeight: 'bold',
                padding: '8px',
                border: '1px solid #dee2e6',
                fontSize: '1rem',
              },
            },
            rows: {
              style: {
                '&:hover': {
                  backgroundColor: '#f1f1f1',
                },
                '&:nth-child(odd)': {
                  boxShadow: 'inset 0 0 0 9999px rgba(0, 0, 0, 0.023)',
                },
              },
            },
          }}
        />)}
      </Box>
    </div>
  );
};

export default MyTable;